<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div
        class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        "
      >
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >หน้าแรก</router-link
              >
            </li>
            <li class="breadcrumb-item router-link active">
              ขอแต่งตั้งตำแหน่ง (หน่วยดำเนินการ)
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div
        class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        "
        style="background-color: #f2f2f2"
      >
        <div class="icon-back">
          <router-link to="/AgenteService">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div
          class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8"
        >
          ขอแต่งตั้งตำแหน่ง (หน่วยดำเนินการ)
        </div>
      </div>
      <!-- Mobile -->
      <div class="col col-content">
        <div class="d-none d-lg-flex align-items-center border-bottom">
          <div class="icon-back">
            <router-link to="/AgenteService">
              <img src="@/assets/images/arrow-blue.svg" class="w-100" />
            </router-link>
          </div>
          <div
            class="
              title
              blue-1
              fw-normal
              ps-md-3
              pe-lg-3
              font-family
              d-none d-md-block d-lg-block
            "
          >
            ขอแต่งตั้งตำแหน่ง (หน่วยดำเนินการ)
          </div>
        </div>
        <div class="pb-3 pb-lg-3 mt-2 mt-lg-1">
          <div class="gray-3 fs-5 font-family">
            ตัวแทนใต้สังกัดที่ต้องการดำเนินการ<span class="required">*</span>
          </div>
          <div class="ps-2 row font-family">
            <div class="col-11" style="padding-right: initial">
              <input
                v-model="AgentCode"
                type="text"
                class="field field__input a-field__input fs-6 bla-placeholder"
                style="border-bottom: 1px solid #d0d0d0; font-family: monospace;"
                @keypress="isNumber($event)"
                placeholder="รหัสตัวแทน"
                maxlength="8"
                @change="format(this.AgentCode)"
              />
            </div>
            <div class="col-1" style="padding-left: inherit">
              <font-awesome-icon
                style="
                  color: #0057a8;
                  width: 24px;
                  height: 24px;
                  margin-top: 25px;
                  cursor: pointer;
                "
                :icon="IconSearch"
                @click="Search(this.AgentCode)"
              />
            </div>
            <div v-if="AS_AGENTCODE !== ''" >
              <label class="font-family fs-5 fw-normal blue-1">{{ PRENAME }} {{ NAME }} {{ SURNAME }}</label><br/>
              <label class="font-family fs-5 fw-normal blue-1">ตำแหน่งปัจจุบัน {{ TITLE }}</label>
            </div>
          </div>
        </div>
        <div class="pb-3 pb-lg-3 mt-2 mt-lg-1">
          <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
            เปลี่ยนเป็น :
          </div>
          <div class="gray-3 fs-5 font-family">
            ตำแหน่งใหม่<span class="required">*</span>
          </div>
          <div class="font-family fs-5 mt-2 mt-lg-1">
            <v-select
              v-model="CHY_POT"
              :reduce="(option) => option.value"
              :options="ListPosition"
              placeholder="กรุณาเลือกตำแหน่ง"
              :disabled="disabled"
            />
          </div>
        </div>
        <div class="pb-3 pb-lg-3 mt-2 mt-lg-1">
          <div class="gray-3 fs-5 font-family">
            ประสบการณ์ในธุรกิจประกันชีวิตจากบริษัทอื่น
          </div>
          <div class="fs-4 font-family">
            <textarea v-model="EXP_DETAIL" class="field field__input a-field__input border-none" style="border-bottom: 1px solid #d0d0d0; resize: none; height: 80px;" aria-label="With textarea" placeholder="ข้อมูลบริษัทเดิม" maxlength="254" :disabled="disabled"></textarea>
          </div>
        </div>
        <div class="pb-3 pb-lg-3 mt-2 mt-lg-1">
          <div class="gray-3 fs-5 font-family">ข้อมูลเพิ่มเติม</div>
          <div class="fs-4 font-family">
            <textarea v-model="AD_INFO_DETAIL" class="field field__input a-field__input border-none" style="border-bottom: 1px solid #d0d0d0; resize: none; height: 80px;" aria-label="With textarea" placeholder="ข้อมูลเพิ่มเติม" maxlength="254" :disabled="disabled"></textarea>
          </div>
        </div>
        <div class="pb-3 pb-lg-3 mt-2 mt-lg-1">
          <div class="gray-3 fs-5 font-family">
            <p style="margin-bottom: 0rem">
              กรณีที่มีประสบการณ์ในธุรกิจประกันชีวิต
            </p>
            <p style="margin-bottom: 0rem">
              ขั้นตอนถัดไป กรุณาเตรียมเอกสารแนบ :
            </p>
          </div>
          <div class="blue-1 fs-5 font-family">
            <p style="margin-bottom: 0rem">
              หลักฐานแสดงว่ามีประสบการณ์ในธุรกิจประกันชีวิต มาจากบริษัท
            </p>
          </div>
        </div>
        <div class="col mt-2 mb-2 mb-lg-2">
          <button class="btn-CB border border-0 rounded w-100 font-family" @click="EnterNext()">
            <label class="btn-next">ดำเนินการต่อ</label>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

export default {
  name: "AssignPositionView",
  components: {
    Menu,
    FontAwesomeIcon,
    LoadingBs5
  },
  data() {
    return {
      IconSearch: faMagnifyingGlass,
      AgentCode: '',
      AS_AGENTCODE: '',
      PRENAME:'',
      NAME: '',
      SURNAME: '',
      AGENTTYPE: '',
      AG_STATUS: '',
      AG_LEVEL: '',
      AG_STLV_SP: '',
      TITLE: '',
      ListPosition: [],
      Loading: true,
      CheckSearch: false,
      CHY_POT: '',
      EXP_DETAIL: '',
      AD_INFO_DETAIL: '',
      disabled: true,
      CHECK_ATTACH_FILE: [],
    };
  },
  mounted() {
    if(this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }

    // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    http.get("AgencyERequest/GetName?",{ headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => { 
      if(res.status == 200) {
        this.$store.state.UserName = res.data.NAME + " " + res.data.SURNAME;
        this.Loading = false;

        let params = { AGENTCODE: res.data.AGENTCODE };
        http.get("AgencyERequest/Permission?", { headers: { Authorization: `Bearer ${AuthorizeToken}` }, params }).then(() => { 
          
        }).catch(() => { 
          console.log("Catch Fond")
          Swal.fire({
            icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">สำหรับผู้บริหารหน่วยดำเนินการเท่านั้น</label>',
          }).then(() => { 
            this.$router.push("/AgenteService");
          });
        });
      }
      else {
        this.Loading = false; 
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
      }
    }).catch((error) => { 
      this.Loading = false; 
      Swal.fire({
        icon: 'error',
        html: '<label class="fs-4 fw-normal font-family">'+ error.response.data.ErrorMessage +'</label>',
      }).then(() => { 
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
      });
    });
  },
  watch: {
    AgentCode() {
      this.AS_AGENTCODE = '';
      this.PRENAME = '';
      this.NAME = '';
      this.SURNAME = '';

      this.AGENTTYPE = '';
      this.AG_STATUS = '';
      this.AG_LEVEL = '';
      this.AG_STLV_SP = '';
      this.TITLE = '';

      this.CHY_POT = null;

      this.CheckSearch = false;

      this.disabled = true;
    }
  },
  methods: {
    Search(val) {
      if(val === '') {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณากรอกรหัสตัวแทนใต้สังกัดที่ต้องการดำเนินการ</label>',
        });
      }
      else {
        this.Loading = true;
        // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
        let AuthorizeToken = localStorage.getItem("AuthorizeToken");
        let params = {
          SEARCH_AGENTCODE: val,
          USER_AG_LEVEL: this.$store.state.User_AG_LEVEL,
          SUBJOB: this.$store.state.ASSIGN_POSITION.SUBJOB
        }; 

        http.get("AgencyERequest/GetAgentChgPosition?", { headers: { Authorization: `Bearer ${AuthorizeToken}` }, params }).then((res) => { 
          if(res.status == 200) {
            this.Loading = false;

            if(res.data.PRENAME == null && res.data.NAME == null && res.data.SURNAME == null) {
              Swal.fire({
              icon: 'error',
                html: '<label class="fs-4 fw-normal font-family">ไม่พบข้อมูลตัวแทน</label>',
              });
              
              this.disabled = true;
            }
            else {
              this.AS_AGENTCODE = res.data.AGENTCODE,
              this.PRENAME = res.data.PRENAME,
              this.NAME = res.data.NAME,
              this.SURNAME = res.data.SURNAME

              this.AGENTTYPE = res.data.AGENTTYPE;
              this.AG_STATUS = res.data.AG_STATUS;
              this.AG_LEVEL = res.data.AG_LEVEL;
              this.AG_STLV_SP = res.data.AG_STLV_SP;
              this.TITLE = res.data.TITLE;

              this.CheckSearch = true;

              let params = {
                CHG_TYPE: String(""),
                AGENTTYPE: this.AGENTTYPE,
                AG_STATUS: this.AG_STATUS, 
                AG_LEVEL: this.AG_LEVEL,
                AG_STLV_SP: this.AG_STLV_SP,
              };

              this.Loading = true;

              this.CHY_POT = null;
              
              http.get("AgencyERequest/GetPosition?", { headers: { Authorization: `Bearer ${AuthorizeToken}` }, params }).then((res) => { 
                if(res.status == 200) {
                  this.ListPosition = [];
                  res.data.forEach((item, index) => {
                    let A = {
                      id: index,
                      label: item.TITLE,
                      value: item.AG_POSITION_ID
                    };
                    
                    this.ListPosition.push(A);

                    this.Loading = false;
                  });
                }
              }).catch((error) => { this.Loading = false; });

              this.disabled = false;
            }
          }
          else {

          }
        }).catch((error) => { this.Loading = false; });
      }
    },
    EnterNext() {
      if(this.AgentCode === '' && !this.CheckSearch) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาระบุตัวแทนใต้สังกัดที่ต้องการดำเนินการ</label>',
        });
      }
      else if (this.CHY_POT ==='' || this.CHY_POT == null) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาระบุตำแหน่งใหม่</label>',
        });
      }
      else {
        this.Loading = true;
        // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
        let AuthorizeToken = localStorage.getItem("AuthorizeToken");
        let CODE = [];
        CODE.push(this.AgentCode);

        let request = {
          AGENTCODE: CODE,
          SUBJOB: this.$store.state.ASSIGN_POSITION.SUBJOB,
        }

        http.post("AgencyERequest/CheckCreateJob?", request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => { 
          if(response.status == 200) {
            if(response.data !== '001' && response.data !== '002') { 
              this.$store.state.PASS_ASSIGN_POSITION.NAME = this.AS_AGENTCODE + " " + this.PRENAME + " " + this.NAME + " " + this.SURNAME;
              this.$store.state.PASS_ASSIGN_POSITION.TITLE = this.TITLE;
              this.ListPosition.forEach(item => {
                if(item.value === this.CHY_POT) {
                  this.$store.state.PASS_ASSIGN_POSITION.CHG_POT = item.label;
                }
              });
              this.$store.state.PASS_ASSIGN_POSITION.MEMO1 = this.EXP_DETAIL;
              this.$store.state.PASS_ASSIGN_POSITION.MEMO2 = this.AD_INFO_DETAIL;

              // //SET INSERT DATA
              this.$store.state.ASSIGN_POSITION.AGENTCODE = this.AgentCode;
              this.$store.state.ASSIGN_POSITION.AGENTCODE_PROMOTE = this.AgentCode;
              this.$store.state.ASSIGN_POSITION.EXP_DETAIL = this.EXP_DETAIL.trim();
              this.$store.state.ASSIGN_POSITION.AD_INFO_DETAIL = this.AD_INFO_DETAIL;
              this.$store.state.ASSIGN_POSITION.AG_POSITION_ID = parseInt(this.CHY_POT);

              this.Loading = false;
              this.$router.push('/FinishAssignPosition');
            }
            else {
              Swal.fire({
                icon: 'error',
                html: '<label class="fs-4 fw-normal font-family">ไม่สามารถทำรายการนี้ได้ เนื่องจากมีการร้องของานไปแล้วก่อนหน้า</label>',
              });
              this.Loading = false;

              this.$router.push("/AgenteService");
            }
          }
        }).catch(() => { 
          this.Loading = false; 
          Swal.fire({
            icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">สำหรับผู้บริหารหน่วยดำเนินการเท่านั้น</label>',
          });
        });
      }
    },
    format(val) { 
      this.AgentCode = String(val).padStart(8, '0');
      return this.AgentCode;
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      let key = evt.key;
      let re = /^\d+.?\d*$/;
      if (re.test(key)) {
        return true;
      } else {
        evt.preventDefault();
      }
    }
  },
};
</script>

<style scoped>
.btn-CB {
  min-height: 50px;
  font-size: 26px;
  font-size: 1.625rem;
  background-color: #0057a8;
}
.border-none:focus {
  outline: none;
}
</style>